import ComingSoon from "../../Components/ComingSoon"

function Profile() {
  return (
    <ComingSoon/>
  )
}

export default Profile